import { Box, Grid, IconButton, InputAdornment } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { useThemeBreakpoints } from "api";
import { Form, Formik } from "formik";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useFirebase } from "react-redux-firebase";
import { Redirect, useLocation } from "react-router";
import { LOGIN_ERROR_MESSAGES } from "redux/reducers/authReducer";
import { BoxCard, InputFieldFormik, SubmitButton, Title } from "ui/componentes";

const PasswordReset = () => {
    const [showPassword, setShowPassword] = useState(false);
    const params = new URLSearchParams(useLocation().search);
    const firebase = useFirebase();
    const { enqueueSnackbar } = useSnackbar();
    const actionCode = params.get("oobCode");
    const { isDownXs } = useThemeBreakpoints();

    return (
        <Box
            id="signIn"
            width="100%"
            height="100vh"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            bgcolor="#F5F5F5"
        >
            <img
                src={`${process.env.PUBLIC_URL}/img/irb_logo.png`}
                style={{ maxHeight: isDownXs ? 100 : 120 }}
                alt="logo_irb"
            />
            {!actionCode && <Redirect to="/" />}
            {!!actionCode && (
                <BoxCard
                    minHeight="200px"
                    maxWidth="400px"
                    display="flex"
                    flexDirection="column"
                    marginTop={2}
                >
                    <Formik
                        initialValues={{ newPassword: "" }}
                        onSubmit={({ newPassword }, { setSubmitting }) => {
                            firebase
                                .auth()
                                .confirmPasswordReset(actionCode, newPassword)
                                .then(() => {
                                    enqueueSnackbar(
                                        "Senha alterada com sucesso!",
                                        {
                                            variant: "success",
                                            autoHideDuration: 3000,
                                        }
                                    );
                                    setTimeout(
                                        () => window.location.replace("/"),
                                        3000
                                    );
                                    setSubmitting(false);
                                })
                                .catch((error) => {
                                    setSubmitting(false);
                                    enqueueSnackbar(
                                        LOGIN_ERROR_MESSAGES[error.code],
                                        {
                                            variant: "error",
                                            autoHideDuration: 12000,
                                        }
                                    );
                                });
                        }}
                    >
                        {() => (
                            <Form>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Title text="Redefinir senha" />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <InputFieldFormik
                                            required
                                            id="newPassword"
                                            name="newPassword"
                                            label="Nova senha"
                                            type={
                                                showPassword
                                                    ? "text"
                                                    : "password"
                                            }
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={() =>
                                                                setShowPassword(
                                                                    !showPassword
                                                                )
                                                            }
                                                            onMouseDown={(e) =>
                                                                e.preventDefault()
                                                            }
                                                        >
                                                            {showPassword ? (
                                                                <Visibility />
                                                            ) : (
                                                                <VisibilityOff />
                                                            )}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <SubmitButton
                                            fullWidth={false}
                                            color="primary"
                                        >
                                            Salvar
                                        </SubmitButton>
                                    </Grid>
                                </Grid>
                            </Form>
                        )}
                    </Formik>
                </BoxCard>
            )}
        </Box>
    );
};

export { PasswordReset };
